import serverCall from "../../serverCall";
import axios from "axios";


const login = async (email, password) => {
  try {
    const response = await serverCall.post(
      `/auth/user/login?email=${email}&password=${password}`
    );

    console.log("response", response);
    return response;
  } catch (error) {
    throw error;
  }
};

const AuthService = {
  login,
};

export default AuthService;
